import { Switch } from "react-router-dom";
import AreaComumPages from "./AreaComumPages";
import UnidadePages from "./UnidadePages";
import FornecedorPages from "./FornecedorPages";
import ClientesPages from "./ClientesPages";
import GrupoUnidadePages from "./GrupoUnidadePages";
import PerfilPages from "./PerfilPages";
import DocumentosPages from "./Documentos";
import AuthRoute from "components/AuthRoute";
import { PermissaoEnum } from "resources/enums/permissao";
import UnidadesUnificadasPages from "./UnidadesUnificadasPages/index";

function CadastrosPages() {
  return (
    <Switch>
      <AuthRoute
        path="/cadastros/areas-comum"
        component={AreaComumPages}
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.AreaComum.Visualizar,
        ]}
      />
      <AuthRoute
        path="/cadastros/unidades"
        component={UnidadePages}
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.Unidade.Visualizar,
        ]}
      />
      <AuthRoute
        path="/cadastros/unidades-unificadas"
        component={UnidadesUnificadasPages}
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.Unidade.Visualizar,
        ]}
      />
      <AuthRoute
        path="/cadastros/perfis"
        component={PerfilPages}
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.Perfil.Visualizar,
        ]}
      />
      <AuthRoute
        path="/cadastros/fornecedores"
        component={FornecedorPages}
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.Fornecedor.Visualizar,
        ]}
      />
      <AuthRoute
        path="/cadastros/clientes"
        component={ClientesPages}
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.Cliente.Visualizar,
        ]}
      />
      <AuthRoute
        path="/cadastros/grupos-unidades"
        component={GrupoUnidadePages}
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.GrupoUnidade.Visualizar,
        ]}
      />
      <AuthRoute
        path="/cadastros/documentos"
        component={DocumentosPages}
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.Documento.Visualizar,
        ]}
      />
    </Switch>
  );
}

export default CadastrosPages;
